<template>
	<div>
		<b-row>
			<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
				<div class="sa-pianificazione-edit-container">
					<label for="">Giorni</label>
					<b-form-checkbox size="lg" class="sa-pianificazione-edit-container-selector" switch @input="onInputDaysAll"><label for="">Tutti</label></b-form-checkbox>
					<b-form-checkbox v-model="daysSelected" v-for="day in days" :key="day.code" :name="day.day" :value="day.code" size="lg" switch class="sa-pianificazione-edit-container-selector">
						<label for="">{{ day.day }}</label>
					</b-form-checkbox>
				</div>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
				<div class="sa-pianificazione-edit-container">
					<div style="display: flex; flex-direction: row">
						<div style="flex: 1">
							<b-row>
								<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
									<b-input-group class="mb-3">
										<label for="">Ora Inizio</label>
										<date-picker format="HH:mm" value-type="timestamp" v-model="oraInizioSelezionata" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time" :disabled="orarioDisabled"></date-picker>
									</b-input-group>
								</b-col>
								<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
									<b-input-group class="mb-3">
										<label for="">Ora Fine</label>
										<date-picker format="HH:mm" value-type="timestamp" v-model="oraFineSelezionata" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time" :disabled="orarioDisabled"></date-picker>
									</b-input-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
									<label for="">Ogni N ore:</label>
									<b-form-input type="number" v-model="numeroOre"></b-form-input>
								</b-col>
								<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
									<label for="">Numero di Ripetizioni:</label>
									<b-form-input type="number" v-model="numeroRipetizioni"></b-form-input>
								</b-col>
							</b-row>
						</div>
					</div>
					<label class="sa-label-data">Ora Programmata:</label>
					<div v-for="(ora, index) in hoursSelected" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
						<div style="flex: 1; display: table">
							<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)">
								{{ ora }}
							</span>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			pianificazione: { params: { oraInizioSelezionata: null, oraFineSelezionata: null, numeroOre: null, numeroRipetizioni: null } },
			days: [],
			daysSelected: [],
			hoursSelected: [],
			btnDisabledAggiungiOrario: true,
			oraInizioSelezionata: null,
			oraFineSelezionata: null,
			orarioDisabled: true,
			numeroOre: null,
			numeroRipetizioni: null,
		};
	},
	created() {
		this.days = UtilityMixin.methods.getDaysOfWeekArray();
	},
	mounted() {
		this.$emit("afterMounted");
	},
	watch: {
		daysSelected() {
			let me = this;
			me.pianificazione.giorni = me.daysSelected ? me.daysSelected.join(",") : "";
			this.$emit("updatePianificazioneOreAlternate", me.pianificazione);
			if (me.daysSelected.length > 0) {
				me.orarioDisabled = false;
				me.btnDisabledAggiungiOrario = false;
			} else {
				me.hoursSelected = [];
				me.orarioDisabled = true;
				me.btnDisabledAggiungiOrario = true;
			}
		},
		hoursSelected() {
			let me = this;
			me.pianificazione.orari = me.hoursSelected ? me.hoursSelected.join(",") : "";
			this.$emit("updatePianificazioneOreAlternate", me.pianificazione);
		},
		oraInizioSelezionata(value) {
			this.pianificazione.params.oraInizioSelezionata = value;
			this.aggiornaOrari();
		},
		oraFineSelezionata(value) {
			this.pianificazione.params.oraFineSelezionata = value;
			this.aggiornaOrari();
		},
		numeroOre(value) {
			this.pianificazione.params.numeroOre = value;
			this.aggiornaOrari();
		},
	},
	methods: {
		getClass(index) {
			if (index % 2 === 0) {
				return "sa-utility-alternate-even";
			} else {
				return "sa-utility-alternate-odd";
			}
		},
		aggiornaOrari() {
			let me = this;
			me.hoursSelected = [];
			let dataOraInizio = new Date(me.oraInizioSelezionata);
			let dataOraFine = new Date(me.oraFineSelezionata);
			if (me.numeroOre) {
				while (dataOraInizio.getTime() < dataOraFine.getTime()) {
					if (dataOraInizio.getTime() < dataOraFine.getTime()) {
						me.hoursSelected.push(me.formatTime(dataOraInizio));
					}
					dataOraInizio.setTime(dataOraInizio.getTime() + me.numeroOre * 60 * 60 * 1000);
				}
			}
		},
		disbilitaOrePrecedenti(date) {
			let me = this;
			let today = new Date();
			let dataRiferimento = new Date(me.pianificazione.dataInizio);
			if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
				return date.getHours() < new Date().getHours();
			} else {
				return false;
			}
		},
		setPianificazione(pianificazione) {
			let me = this;
			me.pianificazione = pianificazione;
			me.daysSelected = pianificazione.giorni ? pianificazione.giorni.split(",") : [];
			me.hoursSelected = pianificazione.orari ? pianificazione.orari.split(",") : [];
			me.pianificazione.params = JSON.parse(me.pianificazione.params);
			me.oraInizioSelezionata = me.pianificazione.params.oraInizioSelezionata;
			me.oraFineSelezionata = me.pianificazione.params.oraFineSelezionata;
			me.numeroOre = me.pianificazione.params.numeroOre;
		},
		onInputDaysAll(value) {
			let me = this;
			me.daysSelected = [];
			if (value) {
				this.days.forEach((element) => {
					me.daysSelected.push(element.code);
				});
			}
		},
		onClickRemoveOrario(index) {
			let me = this;
			me.hoursSelected.splice(index, 1);
		},
		onClickAggiungiOrario() {
			let me = this;
			if (this.oraSelezionata) {
				me.hoursSelected.push(me.formatTime(this.oraSelezionata));
				me.hoursSelected = [...new Set(me.hoursSelected)];
				me.hoursSelected.sort();
			}
		},
	},
};
</script>

<style></style>
